import { weiUnits } from 'viem';
import {} from '../types/unit.js';
export function getUnit(unit) {
    if (typeof unit === 'number')
        return unit;
    if (unit === 'wei')
        return 0;
    return Math.abs(weiUnits[unit]);
}
//# sourceMappingURL=getUnit.js.map